import * as React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { Skeleton } from '@progress/kendo-react-indicators';
import { OverviewPage, StackLayout } from '../../../../ui';
import { ValueItem } from '../../components';
import {
  loadStudentCompetencySurveyOverviewPage,
  selectStudentCompetencySurveyOverviewPageTab,
  closeRequestEvaluationDialog,
  openRequestEvaluationDialog,
  clearStudentCompetencySurveyOverviewPage,
  openQrCodeDialog,
  closeQrCodeDialog,
  setShowQrCodeSetting,
  closeConfirmDialog,
  openConfirmDialog,
  resendNotificationClick
} from '../../student-competency/actions/student-competency-survey-overview-page-actions';
import StudentCompetencySubmittedSurveyList from './student-competency-submitted-survey-list';
import { StudentCompetencySurveySubmitForm } from '.';
import { loadStudentCompetencySubmittedSurveyList } from '../../student-competency/actions/student-competency-submitted-survey-list-actions';
import FormDialog from '../../../../ui/components/application/form-dialog';
import { QRCode } from '@progress/kendo-react-barcodes';
import { withRouter } from '../../../../components/withRouter';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Text } from '../../../../ui';

class StudentCompetencySurveyOverviewPage extends React.PureComponent {

  constructor() {
    super();
    this.handleBreadcrumbItemClick = this.handleBreadcrumbItemClick.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleRequestEvaluationClick = this.handleRequestEvaluationClick.bind(this);
    this.handleResendNotificationClick = this.handleResendNotificationClick.bind(this);
    this.handleActionClick = this.handleActionClick.bind(this);
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.state = {
      surveyLocationAddress: null
    };
  }

  async componentDidMount() {
    if (this.props.params?.competencyId && this.props.params?.competencySurveyId && this.props.studentId) {
      await this.props.loadStudentCompetencySurveyOverviewPage({
        competencyId: this.props.params.competencyId,
        studentId: this.props.studentId,
        competencySurveyId: this.props.params.competencySurveyId
      });
    }
  }

  componentWillUnmount() {
    this.props.clearStudentCompetencySurveyOverviewPage();
  }

  render() {
    const {
      studentCompetencySurvey,
      loading,
      isConfirmDialogVisible,
      confirmDialogMessage,
      successMessage,
      errorMessage
    } = this.props;
    const localizationService = provideLocalizationService(this);

    return (
      <OverviewPage
        title={loading
          ? <Skeleton shape='text' style={{ width: 300, height: 28 }}/>
          : `${studentCompetencySurvey?.surveyName}`
        }
        breadcrumbItems={this.props.breadcrumbItems}
        onBreadcrumbItemClick={this.handleBreadcrumbItemClick}
        onBackClick={this.handleBackClick}
        successMessage={successMessage}
        errorMessage={errorMessage}
        summary={
          <StackLayout rowGap='8px'>
            <ValueItem
              label={localizationService.toLanguageString('studentCompetency.type')}
              labelWidth='150px'
              loading={loading}
            >
              {localizationService.toLanguageString(`surveyType.${studentCompetencySurvey?.surveyType}`)}
            </ValueItem>
            <ValueItem
              label={localizationService.toLanguageString('studentCompetency.code')}
              labelWidth='150px'
              loading={loading}
            >
              {studentCompetencySurvey?.surveyCode}
            </ValueItem>
            <ValueItem
              label={localizationService.toLanguageString('studentCompetency.minCount')}
              labelWidth='150px'
              loading={loading}
            >
              {studentCompetencySurvey?.minCount}
            </ValueItem>
            <ValueItem
              label={localizationService.toLanguageString('studentCompetency.tieredCompetency')}
              labelWidth='150px'
              loading={loading}
            >
              {`${studentCompetencySurvey?.competencyAbbreviation} ${studentCompetencySurvey?.competencyName}`}
            </ValueItem>
          </StackLayout>
        }
        tabs={
          <TabStrip selected={this.props.selectedTab} onSelect={this.handleTabSelect}>
            <TabStripTab title={localizationService.toLanguageString('studentCompetency.submitted')}/>
          </TabStrip>
        }
      >
        {this.props.selectedTab === 0 && studentCompetencySurvey &&
          <StudentCompetencySubmittedSurveyList
            preview={this.props.preview}
            disableRowClick={this.props.preview}
            studentId={studentCompetencySurvey.studentId}
            competencyId={studentCompetencySurvey.competencyId}
            surveyId={studentCompetencySurvey.surveyId}
            studentCompetencyStatus={studentCompetencySurvey.studentCompetencyStatus}
            handleRequestEvaluationClick={this.handleRequestEvaluationClick}
            handleResendNotificationClick={this.handleResendNotificationClick}
          />
        }
        {this.props.isRequestEvaluationDialogVisible &&
          <StudentCompetencySurveySubmitForm
            onCancel={this.props.closeRequestEvaluationDialog}
            studentId={studentCompetencySurvey.studentId}
            competencySurvey={this.props.studentCompetencySurvey}
            setShowQrCodeSetting={this.props.setShowQrCodeSetting}
            shouldShowQrCode={this.props.shouldShowQrCode}
            afterSubmit={(payload) => {
              this.setState({ surveyLocationAddress: payload.surveyLocationAddress });
              if (payload.surveyLocationAddress) {
                this.props.openQrCodeDialog();
              }
              this.props.loadStudentCompetencySubmittedSurveyList({ competencyId: studentCompetencySurvey.competencyId, surveyId: studentCompetencySurvey.surveyId, studentId: this.props.studentId });
            }}
          />
        }
        {this.props.isQrCodeDialogVisible && this.state.surveyLocationAddress && this.props.shouldShowQrCode &&
          <FormDialog
            title={localizationService.toLanguageString('studentCompetency.qrCode')}
            confirmButtonText={localizationService.toLanguageString('buttons.close')}
            onSubmit={this.props.closeQrCodeDialog}
            onCancel={this.props.closeQrCodeDialog}
            hideCloseButton={true}
            width={'300px'}
            render={() => (
              <QRCode
                value={this.state.surveyLocationAddress}
                errorCorrection='M'
                renderAs={'svg'}
                size={'250px'}
              />
            )}
          />
        }
        {isConfirmDialogVisible &&
          <Dialog
            title={localizationService.toLanguageString('custom.confirm')}
            onClose={this.props.closeConfirmDialog}
          >
            <Text>{confirmDialogMessage}</Text>
            <DialogActionsBar>
              <Button themeColor={'primary'} onClick={this.handleConfirmClick}>
                {localizationService.toLanguageString('buttons.yes')}
              </Button>
              <Button onClick={this.props.closeConfirmDialog}>
                {localizationService.toLanguageString('buttons.cancel')}
              </Button>
            </DialogActionsBar>
          </Dialog>
        }
      </OverviewPage>
    );
  }

  handleRequestEvaluationClick(e) {
    this.props.openRequestEvaluationDialog(e.dataItem);
  }

  handleTabSelect(e) {
    this.props.selectStudentCompetencySurveyOverviewPageTab({
      selected: e.selected
    });
  }

  handleBreadcrumbItemClick(e) {
    if (e.id === 'myCompetencies') {
      this.props.navigate('/my_competencies');
    }
    if (e.id === 'myCompetency') {
      this.props.navigate(`/my_competencies/${this.props.params.competencyId}/overview`);
    }

    if (e.id === 'students') {
      this.props.navigate('/students');
    }
    if (e.id === 'student') {
      this.props.navigate(`/students/${this.props.params.studentId}/overview`);
    }
    if (e.id === 'studentCompetency') {
      this.props.navigate(`/students/${this.props.params.studentId}/competencies/${this.props.params.competencyId}/overview`);
    }
  }

  handleBackClick() {
    this.props.navigate(-1);
  }

  handleActionClick(payload, message, confirmAction) {
    this.props.openConfirmDialog({ ...payload, message, confirmAction });
  }

  handleConfirmClick() {
    this.props.confirmDialogAction();
    this.props.closeConfirmDialog();
  }

  handleResendNotificationClick(payload) {
    const localizationService = provideLocalizationService(this);
    this.handleActionClick(
      payload,
      localizationService.toLanguageString('studentCompetency.resendNotificationDialogMessage'),
      () => this.props.resendNotificationClick({ localizationService })
    );
  }
}

registerForLocalization(StudentCompetencySurveyOverviewPage);

const mapStateToProps = state => ({
  studentCompetencySurvey: state.studentCompetencySurveyOverview.studentCompetencySurvey,
  loading: state.studentCompetencySurveyOverview.loading,
  selectedTab: state.studentCompetencySurveyOverview.selectedTab,
  isRequestEvaluationDialogVisible: state.studentCompetencySurveyOverview.isRequestEvaluationDialogVisible,
  requestEvaluationDialogValidationResult: state.studentCompetencySurveyOverview.requestEvaluationDialogValidationResult,
  isQrCodeDialogVisible: state.studentCompetencySurveyOverview.isQrCodeDialogVisible,
  shouldShowQrCode: state.studentCompetencySurveyOverview.shouldShowQrCode,
  isConfirmDialogVisible: state.studentCompetencySurveyOverview.isConfirmDialogVisible,
  confirmDialogMessage: state.studentCompetencySurveyOverview.confirmDialogMessage,
  confirmDialogAction: state.studentCompetencySurveyOverview.confirmDialogAction,
  successMessage: state.studentCompetencySurveyOverview.successMessage,
  errorMessage: state.studentCompetencySurveyOverview.errorMessage
});

const mapDispatchToProps = dispatch => ({
  loadStudentCompetencySurveyOverviewPage: (payload) => dispatch(loadStudentCompetencySurveyOverviewPage(payload)),
  selectStudentCompetencySurveyOverviewPageTab: (payload) => dispatch(selectStudentCompetencySurveyOverviewPageTab(payload)),
  closeRequestEvaluationDialog: () => dispatch(closeRequestEvaluationDialog()),
  openRequestEvaluationDialog: (payload) => dispatch(openRequestEvaluationDialog(payload)),
  loadStudentCompetencySubmittedSurveyList: (payload) => dispatch(loadStudentCompetencySubmittedSurveyList(payload)),
  clearStudentCompetencySurveyOverviewPage: (payload) => dispatch(clearStudentCompetencySurveyOverviewPage(payload)),
  openQrCodeDialog: () => dispatch(openQrCodeDialog()),
  closeQrCodeDialog: () => dispatch(closeQrCodeDialog()),
  setShowQrCodeSetting: (payload) => dispatch(setShowQrCodeSetting(payload)),
  resendNotificationClick: (payload) => dispatch(resendNotificationClick(payload)),
  openConfirmDialog: (payload) => dispatch(openConfirmDialog(payload)),
  closeConfirmDialog: (payload) => dispatch(closeConfirmDialog(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudentCompetencySurveyOverviewPage));
